import styled, { css } from 'styled-components';
import BaseIcon from '../../../../../ui/Icon';
import {
  colors,
  spacing,
  typography,
} from '../../../../../../styles/theme';

interface IconProps {
  readonly checked: boolean;
}

export const ItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing('2')};
`;

export const ItemDetailsWrapper = styled.div`
  flex: 1;
`;

export const Title = styled.p`
  font-size: ${typography('fontSize')};
  font-weight: ${typography('weights.semibold')};
  margin-bottom: ${spacing('small')};
  line-height: 24px;
`;

export const Icon = styled(BaseIcon) <IconProps>`
  font-size: 24px;
  opacity: 0.1;
  flex-shrink: 0;

  ${({ checked }: IconProps) =>
    checked &&
    css`
      opacity: 1;
    `}
`;

export const EmptySpace = styled.div`
  width: 24px;
  height: 24px;
`;

export const CompositionsList = styled.div`
  font-size: ${typography('caption1.fontSize')};
  line-height: ${typography('caption1.lineHeight')};
  color: ${colors('neutral.base')};
`;

export const CidBlock = styled.div`
  margin-top: ${spacing('2')};
  max-width: 100%;
`;

export const CidDescription = styled.p`
  font-size: ${typography('caption1.fontSize')};
  line-height: ${typography('caption1.lineHeight')};
  color: ${colors('black.base')};
  margin: 0 0 ${spacing('1')} 0;
  word-break: break-word;

  strong {
    font-weight: ${typography('weights.bold')};
  }
`;
